<!--
Loads a result file and makes it available via the XXX field.

-->
<script>
import JobMixin from "@/mixins/job.vue";
export default {
  mixins: [JobMixin],
  props: ["seq_id"],
  data: function() {
    return {
      content: null
    };
  },
  computed: {
    files: function() {
      if (this.job == null) {
        return [];
      } else {
        return this.job.data.files.filter(f => f.name.startsWith(this.seq_id));
      }
    },
    resultFile: function() {
      let results = this.files.filter(f => f.type === "result");
      if (results) {
        return results[0];
      } else {
        return null;
      }
    },
    dbxrefsMap: function() {
      if (this.content == null || this.content.dbxrefs == null) {
        return {};
      } else {
        let map = {};
        this.content.dbxrefs.forEach(x => (map[x.id] = x));
        return map;
      }
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    job: function(v) {
      if (this.resultFile) {
        this.loadFile(this.resultFile.name);
      } else {
        this.$router.replace({ path: "/notfound" });
      }
    }
  },
  methods: {
    loadFile: function(file) {
      var vm = this;
      if (this.job_id !== null && file !== null) {
        this.psosService.file(
          this.job_id,
          file,
          function(data) {
            vm.loading = false;
            vm.notFound = false;
            vm.content = data.json;

            if (vm.dbxrefServiceUrl) {
              vm.referencedDatabaseEntries.forEach(function(dbxref) {
                vm.content.dbxrefs[dbxref].link =
                  vm.dbxrefServiceUrl + vm.content.dbxrefs[dbxref].id;
              });
            }
          },
          function(error) {
            vm.loading = false;
            vm.notFound = true;
            vm.content = null;
            vm.message = { text: "Error: " + error, variant: "danger" };
          }
        );
      }
    }
  }
};
</script>
